import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/BouwInvest-Frontend/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/BouwInvest-Frontend/src/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientPlatformBanner"] */ "/home/vsts/work/1/s/BouwInvest-Frontend/src/components/organisms/platformBanner/ClientPlatformBanner.ts");
;
import(/* webpackMode: "eager", webpackExports: ["ClientEnvironmentContext"] */ "/home/vsts/work/1/s/BouwInvest-Frontend/src/utils/globalConfig/clientEnvironmentContext.tsx");
